<script>
import { mapActions } from "vuex";

import API from "@/api";

import Loader from "@/components/_base/Loader";
import Card from "./components/Card";

export default {
  components: {
    Loader,
    Card
  },

  data() {
    return {
      preloader: false,
      creditCards: [],
      error: false
    };
  },

  methods: {
    ...mapActions("toast", ["setErrorToast"]),

    async getCreditCards() {
      try {
        this.preloader = true;

        this.creditCards = await API.CreditCards.index();
        this.error = false;
      } catch (e) {
        this.setErrorToast("Ocorreu um erro ao buscar os cartões salvos.");
        this.creditCards = [];
        this.error = true;
      }

      this.preloader = false;
    },

    async handleCardUpdating() {
      await this.getCreditCards();
    }
  },

  computed: {
    storedCreditCards: function() {
      return this.creditCards && this.creditCards.length;
    }
  },

  async mounted() {
    await this.getCreditCards();
  }
};
</script>

<template>
<div class="root-credit-cards">
  <div class="loader" v-if="preloader">
    <Loader />
    <p>Buscando os cartões de crédito salvos...</p>
  </div>

  <div v-else-if="!preloader && storedCreditCards" class="credit-cards">
    <template v-for="creditCard in creditCards">
      <Card
        :card="creditCard"
        :key="creditCard.id"
        @updateCard="handleCardUpdating"
      />
    </template>
  </div>

  <div v-else>
    <div  v-if="this.error" class="error">
      <p>
        Não foi possível buscar os cartões de crédito salvos. Tente novamente clicando no botão abaixo e caso o problema persista entre em contato com o nosso suporte.
      </p>

      <button class="btn bg-purple" @click="getCreditCards">
        <span>Buscar cartões salvos</span>
      </button>
    </div>

    <p v-else class="empty">
      Não encontramos cartões de crédito salvos. Você poderá salvar um cartão ao realizar um pagamento de uma limpeza ou assinatura.
    </p>
  </div>
</div>
</template>

<style scoped>
.root-credit-cards {
  width: 100%;
}

.loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.credit-cards {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.credit-cards > * {
  margin: 12px;
}

.error {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.empty {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/CreditCards/Index.vue